import BannerBlock from '@infl-ts/ui-blocks/src/lib/leafs/banner';
import FooterBlock from '@infl-ts/ui-blocks/src/lib/leafs/footer';
import NavBlock from '@infl-ts/ui-blocks/src/lib/leafs/nav';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';

export const AchievementsBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/achievements').then(mod => mod.default)
);

export const ActivityFeedBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/activity-feed').then(mod => mod.default)
);

export const ChallengeCarouselBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/challenge-carousel').then(mod => mod.default)
);

export const ChallengeListBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/challenge-list').then(mod => mod.default)
);

export const ChannelPageBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/channel-page').then(mod => mod.default)
);

export const ChatPageBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/chat-page').then(mod => mod.default)
);

export const EditProfileBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/edit-profile').then(mod => mod.default)
);

export const ErrorBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/error').then(mod => mod.default)
);

export const HtmlBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/html').then(mod => mod.default)
);

export const LeaderboardBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/leaderboard').then(mod => mod.default)
);

export const NotFoundBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/not-found').then(mod => mod.default)
);

export const PrivacyPolicyBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/privacy-policy').then(mod => mod.default)
);

export const ProfileAchievementsBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/profile-achievements').then(mod => mod.default)
);

export const ProfileActivityFeedBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/profile-activity-feed').then(mod => mod.default)
);

export const ProfileBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/profile').then(mod => mod.default)
);

export const ProfilePageBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/profile-page').then(mod => mod.default)
);

export const ReferPageBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/refer-page').then(mod => mod.default)
);

export const ReferralDashboardBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/referral-dashboard').then(mod => mod.default)
);

export const RewardDetailsPageBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/reward-details-page').then(mod => mod.default)
);

export const RewardsBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/rewards').then(mod => mod.default)
);

export const RewardsPageBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/rewards-page').then(mod => mod.default)
);

export const StreakerBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/streaker').then(mod => mod.default)
);

export const TermsAndConditionsBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/terms-and-conditions').then(mod => mod.default)
);

export const TextBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/text').then(mod => mod.default)
);

export const WishlistBlock = dynamic(() =>
  import('@infl-ts/ui-blocks/src/lib/leafs/wishlist').then(mod => mod.default)
);

export const LeafBlocks = {
  AchievementsBlock,
  ActivityFeedBlock,
  BannerBlock,
  ChallengeCarouselBlock,
  ChallengeListBlock,
  ChannelPageBlock,
  ChatPageBlock,
  EditProfileBlock,
  ErrorBlock,
  FooterBlock,
  HtmlBlock,
  LeaderboardBlock,
  NavBlock,
  NotFoundBlock,
  PrivacyPolicyBlock,
  ProfileAchievementsBlock,
  ProfileActivityFeedBlock,
  ProfileBlock,
  ProfilePageBlock,
  ReferPageBlock,
  ReferralDashboardBlock,
  RewardDetailsPageBlock,
  RewardsBlock,
  RewardsPageBlock,
  StreakerBlock,
  TermsAndConditionsBlock,
  TextBlock,
  WishlistBlock
} as Record<string, ComponentType<unknown>>;
